import {
    GET_PAY_VENDOR_BILL_CREDIT_REQUEST,
    GET_PAY_VENDOR_BILL_CREDIT_SUCCESS,
    GET_PAY_VENDOR_BILL_CREDIT_ERROR,
} from "./types";

import { BASEURL } from "../../constant/config.js";

const axios = require("axios");

export const getPayVendorBillCredit = (token, id) => (dispatch) => {
    dispatch({ type: GET_PAY_VENDOR_BILL_CREDIT_REQUEST });
    return axios({
        method: "POST",
        url: `${BASEURL}getAll/vendorpendingbillgrid`,
        headers: {
            Accept: "application/json",
            Authorization: "Bearer " + token,
        },
        data: { vendor_id: id }
    })
        .then((response) => {
            return dispatch({ type: GET_PAY_VENDOR_BILL_CREDIT_SUCCESS, payload: response.data });
        })
        .catch((error) => {
            return dispatch({
                type: GET_PAY_VENDOR_BILL_CREDIT_ERROR,
                payload: error.response,
            });
        });
};
